/**
 * Team Accordion Functionality
 * Handles show/hide of team members based on responsive breakpoints
 */

function isFrench() {
  return window.location.pathname.startsWith("/fr/");
}

console.log('new version')

export default function initTeamAccordion() {
  const teamAccordions = document.querySelectorAll("[data-team-accordion]");

  if (!teamAccordions.length) return;

  teamAccordions.forEach(initializeTeamAccordion);

  // Re-initialize on window resize to handle responsive breakpoints
  let resizeTimeout;
  let lastWidth = window.innerWidth;
  const RESIZE_TOLERANCE = 5;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const currentWidth = window.innerWidth;
      if (Math.abs(currentWidth - lastWidth) < RESIZE_TOLERANCE) return;
      lastWidth = currentWidth;

      teamAccordions.forEach(reinitializeTeamAccordion);
    }, 250);
  });

  function initializeTeamAccordion(accordion) {
    const seeMoreContainer =
      accordion.parentElement.querySelector(".js-see-more");
    const seeMoreBtn = seeMoreContainer?.querySelector(".team__see-more-btn");
    const countElement = seeMoreContainer?.querySelector(".count-number");
    const members = accordion.querySelectorAll(".team__member");

    if (!seeMoreBtn || !members.length) return;

    // Set up initial state
    setupInitialState(accordion);

    // Add click event listener
    seeMoreBtn.addEventListener("click", function () {
      toggleAccordion(accordion);
    });
  }

  function reinitializeTeamAccordion(accordion) {
    // Reset expanded state on resize
    const seeMoreBtn = accordion.querySelector(".team__see-more-btn");
    if (seeMoreBtn) {
      seeMoreBtn.setAttribute("aria-expanded", "false");
    }

    // Re-setup initial state for new breakpoint
    setupInitialState(accordion);
  }

  function setupInitialState(accordion) {
    const members = accordion.querySelectorAll(".team__member");
    const seeMoreContainer =
      accordion.parentElement.querySelector(".js-see-more");
    const seeMoreText = seeMoreContainer.querySelector(".js-see-text");
    const countElement = seeMoreContainer?.querySelector(".count-number");
    const limits = getBreakpointLimits();
    const totalMembers = members.length;
    const visibleCount = Math.min(totalMembers, limits.visible);
    const hiddenCount = Math.max(0, totalMembers - limits.visible);
    // Show/hide members based on current breakpoint

    if (isFrench()) {
      seeMoreText.textContent = "Voir plus";
    } else {
      seeMoreText.textContent = "See more";
    }
    members.forEach((member, index) => {
      if (index > limits.visible - 1) {
        member.classList.add("team__member--hidden");
        member.classList.remove("team__member--expanded");
      } else {
        member.classList.remove("team__member--hidden");
        member.classList.add("team__member--expanded");
      }
    });

    // Show/hide the "See more" button
    if (hiddenCount > 0) {
      seeMoreContainer.style.display = "flex";
      if (countElement) {
        countElement.textContent = hiddenCount;
      }
    } else {
      seeMoreContainer.style.display = "none";
    }
  }

  function toggleAccordion(accordion) {
    const y =
      accordion.parentElement.getBoundingClientRect().top + window.scrollY - 50;
    const seeMoreContainer =
      accordion.parentElement.querySelector(".js-see-more");
    const seeMoreBtn = seeMoreContainer?.querySelector(".team__see-more-btn");
    const hiddenMembers = accordion.querySelectorAll(
      ".team__member.team__member--hidden"
    );
    const seeMoreText = seeMoreContainer.querySelector(".js-see-text");

    const isExpanded = seeMoreBtn.getAttribute("aria-expanded") === "true";
    if (isExpanded) {
      // Collapse: hide members beyond the limit
      window.scrollTo({ top: y });
      if (isFrench()) {
        seeMoreText.textContent = "Voir plus";
      } else {
        seeMoreText.textContent = "See more";
      }
      hiddenMembers.forEach((member) => {
        member.classList.remove("team__member--expanded");
      });

      seeMoreBtn.setAttribute("aria-expanded", "false");
    } else {
      // Expand: show all hidden members
      if (isFrench()) {
        seeMoreText.textContent = "Voir moins";
      } else {
        seeMoreText.textContent = "See less";
      }
      hiddenMembers.forEach((member) => {
        member.classList.add("team__member--expanded");
      });
      seeMoreBtn.setAttribute("aria-expanded", "true");
    }
  }

  function getBreakpointLimits() {
    const width = window.innerWidth;

    if (width >= 992) {
      // lg breakpoint
      return { visible: 8, perRow: 4 };
    } else if (width >= 768) {
      // md breakpoint
      return { visible: 6, perRow: 3 };
    } else {
      // sm and below
      return { visible: 4, perRow: 2 };
    }
  }
}
